import React from 'react'
import { ThemeType } from '../../containers/CoursePage/types'

// Styles
import './styles.scss'

// Icons
import IconDefaultLesson from '../MapHelperBlock/images/iconDefaultLesson'
import IconCompleteLesson from '../MapHelperBlock/images/iconCompleteLesson'
import IconBlockedLesson from '../MapHelperBlock/images/iconBlockedLesson'
import IconTimeLesson from '../MapHelperBlock/images/iconTimeLesson'

export default ({ themes }: { themes: ThemeType[] | null }) => {
  const lessonTypes = [
    { icon: <IconDefaultLesson />, title: 'Доступный урок' },
    { icon: <IconCompleteLesson />, title: 'Выполненный урок' },
    {
      icon: <IconTimeLesson />,
      title: (
        <>
          Урок, который будет доступен
          <br />в определенное время
        </>
      ),
    },
    {
      icon: <IconBlockedLesson />,
      title: (
        <>
          Недоступный
          <br />
          урок
        </>
      ),
    },
  ]

  return (
    <div className={'module-helper-block'}>
      <div className={'module-helper-block__themes'}>
        {themes
          ? themes.map(theme => (
              <div
                key={theme.theme_id}
                className={'module-helper-block__themes-item'}
              >
                <div className={'circle'} style={{ background: theme.color }} />
                <span>
                  Тема урока:
                  <br />
                  {theme.title}
                </span>
              </div>
            ))
          : null}
      </div>
      <div className={'module-helper-block__legend'}>
        {lessonTypes.map((type, index) => (
          <div
            key={`lesson-type-${index}`}
            className={'module-helper-block__legend-item'}
          >
            {type.icon}
            <span>{type.title}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
